import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-download-qr-code-modal',
  templateUrl: './download-qr-code-modal.component.html',
  styleUrl: './download-qr-code-modal.component.scss',
  standalone: false
})
export class DownloadQrCodeModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  
  @Input()
  qrCodeImageUrl!: string;
  
  @Input() showCopyButton: boolean = false;
  @Input() copyButtonText: string = '';

  @Output() copyUrlClicked = new EventEmitter<void>();

  @ViewChild('photo') photoRef!: ElementRef<HTMLImageElement>;
  
  constructor(
    private translateService: TranslateService,
    private toastrService: ToastrService
  ) {
  }

  close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }

  async downloadPhoto() {
    try {
      const response = await fetch(this.qrCodeImageUrl, { mode: 'cors' });
      const blob = await response.blob();

      const urlParts = this.qrCodeImageUrl.split('/');
      const filename = urlParts[urlParts.length - 1].split('?')[0] || 'qr-code.png';

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      this.toastrService.warning(
        this.translateService.instant("DOWNLOAD.DOWNLOAD-FAILED")
      );
    }
  }

  async copyQRCodeToClipboard() {
    try {
      const response = await fetch(this.qrCodeImageUrl);
      const blob = await response.blob();
      const clipboardItem = new ClipboardItem({ [blob.type]: blob });
      await navigator.clipboard.write([clipboardItem]);

      this.toastrService.success(
        this.translateService.instant("QR-CODE.COPY-SUCCESS")
      );
    } catch (error) {
      this.toastrService.warning(
        this.translateService.instant("QR-CODE.COPY-FAILURE")
      );
    }
  }

  copyUrlToClipboard() {
    this.copyUrlClicked.emit();
  }
}
